module.exports = __webpack_public_path__ + "static/media/Lickitung_gaussian2.1b422cee.png";